
































































import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";
import iwDropdown from "@/shared/components/Dropdown.vue";
import { mapState } from "vuex";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect,
        iwDropdown: iwDropdown
    },

    props: {
        isMobile: {
            type:Boolean,
            required: false,
            default:false
        }
    },

    data: function() {
        return {
            triggerStyle: "filter--mobile" as string,
            selectedTransactionType: "ALL" as string,
            internalTransactionType: "ALL" as string
        };
    },

    computed: {
        ...mapState("MyClassifiedsModule", ["filterTransactionType"]),

        options: function(): Array<Record<string, unknown>> {
            let sell = this.$t("sell") as string;
            let rent = this.$t("rent") as string;
            return [
                {
                    "label": this.$t("all_transaction_types"),
                    "value": "ALL",
                },
                {
                    "label": sell.charAt(0).toUpperCase() + sell.slice(1),
                    "value": "FOR_SALE"
                },
                {
                    "label": rent.charAt(0).toUpperCase() + rent.slice(1),
                    "value": "FOR_RENT"
                },
            ];
        },
        title: function() : string {
            let translation = "ALL" as string;
            switch(this.filterTransactionType) {
            case "ALL":
                translation = "all_transaction_types";
                break;
            case "FOR_SALE":
                translation = "sell";
                break;
            case "FOR_RENT":
                translation = "rent";
                break;
            }
            return translation;
        }
    },

    mounted: function() {
        this.selectedTransactionType = this.filterTransactionType;
        this.internalTransactionType = this.filterTransactionType;

        if(this.isMobile) {
            this.triggerStyle = "filter--mobile";
        } else {
            this.triggerStyle = "filter filter--result-list";
        }
    },

    methods: {
        filterValue: function (transactionType: string) {
            this.$store.commit("MyClassifiedsModule/setFilterTransactionType", transactionType);
            this.$emit("filter-value", transactionType);
        },
        apply: function()  {
            this.$store.commit("MyClassifiedsModule/setFilterTransactionType", this.internalTransactionType);
            this.$emit("filter-value", this.internalTransactionType);
            this.$emit("close-mobile-overlay");
        }
    }
});
